module.exports = "https://www.gc-qa.gnp.com.mx/e5e4514e4d3af124aeb48f9383219e5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/actualizacion/3.png
// module id = 1003
// module chunks = 0 1